import { useCallback, useState } from "react";
import { isEmpty } from "lodash";
import { ExpressionField } from "../../../components/molecules";
import NodeCollectionModal from "../../../components/organisms/AppModals/ServiceModals/NodeCollectionModal";
import {
  serviceFunctionIcon,
  jsonIcon,
  documentIcon,
} from "../../../assets/icons";
import ManageEditor from "./ManageEditor";
import { FIELDS, ACE_EDITOR_FIELDS } from "../datamodels.constants";
import { EMPTY_STRING } from "../../../constants";

const { APPLICATION_JSON, HTML_MESSAGE, TEXT_MESSAGE, JS_CODE ,PDF_MESSAGE} = FIELDS;

const icons = {
  [APPLICATION_JSON]: jsonIcon,
  [TEXT_MESSAGE]: documentIcon,
  [HTML_MESSAGE]: documentIcon,
  [PDF_MESSAGE]: documentIcon,
  [JS_CODE]: jsonIcon,
};

const getClasses = (key) =>
  ACE_EDITOR_FIELDS.includes(key) ? "h-40" : EMPTY_STRING;

const ManageExpression = ({
  name,
  values,
  expressionKey,
  handleChange,
  nodes,
  edges,
  className,
  helperText,
  inputLinks,
}) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [validationObject, setValidationObject] = useState({});

  const handleFunctionalExpression = useCallback(() => setShouldShow(true), []);

  const renderInputHandles = () =>
    !isEmpty(inputLinks) && (
      <div className="py-1">
        <div className="text-[10px] italic">
          To access the input values in your JavaScript code, prefix input names
          with "rjc.".
        </div>
        <div className="flex flex-wrap text-xs">
          {inputLinks.map(({ name }) => (
            <div className="bg-gray-700 rounded-lg p-1 mb-1 mr-1" key={name}>
              {`rjc.${name}`}
            </div>
          ))}
        </div>
      </div>
    );

  const getRequiredModel = (key) =>
    ACE_EDITOR_FIELDS.includes(key) ? (
      <ManageEditor
        title={name}
        nodes={nodes}
        edges={edges}
        values={values}
        shouldShow={shouldShow}
        handleChange={handleChange}
        setShouldShow={setShouldShow}
        expressionKey={expressionKey}
        helperText={helperText}
      />
    ) : (
      <NodeCollectionModal
        title={name}
        nodes={nodes}
        edges={edges}
        values={values}
        shouldShow={shouldShow}
        handleChange={handleChange}
        setShouldShow={setShouldShow}
        expressionKey={expressionKey}
        setValidationObject={setValidationObject}
      />
    );

  return (
    <>
      {expressionKey === JS_CODE && renderInputHandles()}
      <ExpressionField
        name={name}
        values={values}
        handleChange={handleChange}
        handleFunctionalExpression={handleFunctionalExpression}
        expressionKey={expressionKey}
        serviceExpressionIcon={icons[expressionKey] || serviceFunctionIcon}
        className={`${className} ${getClasses(expressionKey)}`}
        validationObject={validationObject}
      />
      {shouldShow && getRequiredModel(expressionKey)}
    </>
  );
};

export default ManageExpression;
